module.exports = __webpack_public_path__ + "static/media/ic_check-circle-green.1545b1f7.svg";